export const MAIN_TITLE = "IMITI";
